module.exports = __webpack_public_path__ + "img/wxapp_code.6331fdaf.jpg";